import React, { PropTypes } from 'react';
import { compose, pure } from 'recompose';
import { connect } from 'react-redux';
import { createAnswer, updateAnswer } from 'funnel/actions/answer';
import ResourceCard from 'common/components/ResourceCard';
import AnswerForm from 'funnel/components/AnswerForm';

const addButtonLabel = props =>
  props.params.question ? 'Créer' : 'Mettre à jour';

const mapStateToProps = (state, ownProps) => {
  const { id } = ownProps.params;
  return {
    current: id ? state.funnels.answers.items.get(id) : null,
  };
};
const mapDispatchToProps = (dispatch, ownProps) => ({
  saveAnswer: fields => {
    const { id, question } = ownProps.params;
    if (question) {
      return dispatch(createAnswer(question, fields));
    } else if (id) {
      return dispatch(updateAnswer(id, fields));
    }
  },
});
class AnswerPage extends React.Component {
  static propTypes = {
    current: PropTypes.object,
    saveAnswer: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {};

    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(fields) {
    const { image } = this.refs;

    const toSave = Object.assign({}, fields, {
      image: image.getResource(),
      image_id: image.getValue(),
    });

    this.props.saveAnswer(toSave);
  }

  render() {
    const { current } = this.props;

    let resource, raw;
    if (current && current.image) {
      if (current.image.id) {
        resource = current.image.id;
      } else {
        raw = current.image;
      }
    }

    return (
      <div className="ui segment">
        <div className="ui grid">
          <div className="four wide column">
            <ResourceCard
              ref="image"
              name="image"
              title="Image"
              resource={resource}
              raw={raw}
            />
          </div>
          <div className="twelve wide column">
            <AnswerForm
              answer={current}
              label={addButtonLabel(this.props)}
              onSubmit={this.onSubmit}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), pure)(
  AnswerPage
);



// WEBPACK FOOTER //
// ./src/modules/funnel/pages/AnswerPage.js